const configs = [
	{
		host: 'easyplus.fr',
		apiUrl: '//api.thunderchild.es/',
		apiKey: 'easyplus-fr',
		locale: 'fr-FR',
		currency: 'EUR',
		title: 'EasyPlus',
		// googleAnalyticsId: '',
		favicon: 'https://cdn.thunderchild.es/easyplus-fr/favicon.ico'
	}
]

const config = configs.find(config => config.host === window.location.hostname)

export default config || {
	host: 'localhost',
	apiUrl: 'https://api.thunderchild.es/',
	apiKey: 'easyplus-fr',
	locale: 'fr-FR',
	currency: 'EUR',
	title: 'EasyPlus',
	// googleAnalyticsId: 'UA-109318970-1',
	favicon: 'https://cdn.thunderchild.es/easyplus-fr/favicon.ico'
}



// WEBPACK FOOTER //
// ./src/utils/config.js